export default "__VITE_ASSET__BTy0o7Y2__"